import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Handles the org picker modal for selecting specific organizations.
//
// In auto_save mode, PATCHes visibility_target_gids to updateUrl.
// In form mode, dispatches a custom event with the selected GIDs
// so the parent visible-to-selector controller can update its hidden field.
export default class extends Controller {
  static values = {
    mode: { type: String, default: "auto_save" },
    updateUrl: String
  }

  apply(event) {
    event.preventDefault()

    const checked = this.element.querySelectorAll("input[type=checkbox]:checked")
    const gids = Array.from(checked).map(cb => cb.dataset.gid)
    if (gids.length === 0) return

    const gidsString = gids.join(",")

    if (this.modeValue === "auto_save" && this.updateUrlValue) {
      this.submitVisibility(gidsString)
    } else {
      // Dispatch event for form-based mode — parent controller listens for this
      window.dispatchEvent(new CustomEvent("visibility-orgs-selected", {
        detail: { gids: gidsString }
      }))
    }

    this.closeModal()
  }

  updateSelection() {
    // No-op for now — could add validation (e.g., at least one checked)
  }

  submitVisibility(gids) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken
      },
      body: `visibility_target_gids=${encodeURIComponent(gids)}`
    }).then(response => {
      if (response.ok) return response.text()
    }).then(html => {
      if (html) Turbo.renderStreamMessage(html)
    })
  }

  closeModal() {
    const modal = document.getElementById("secondary_modal")
    if (modal) {
      modal.classList.remove("modal-open")
      // Defer style cleanup until after the CSS transition finishes
      const modalBox = modal.querySelector(".modal-box")
      if (modalBox) {
        modalBox.addEventListener("transitionend", () => {
          modalBox.style.removeProperty("position")
          modalBox.style.removeProperty("top")
          modalBox.style.removeProperty("left")
        }, { once: true })
      }
    }
  }
}
